<template>
  <div class="containerBox">
    <p class="title">{{ $t('AccountInfo.AccountInvoice.invoiceManagement') }}</p>
    <div class="list">
      <div v-for="(item, index) in invoiceArray"
           :key="index"
           class="item">
        <money-collect-filled class="icon" />
        <div class="info">
          <div class="main">
            <span class="name">{{ item.title }} </span>
            <a-tag color="#EC9231"
                   class="type">{{ item.title_type == 0 ? $t('AccountInfo.AccountInvoice.personal') : (item.title_type
                    ==
                    1 ? $t('AccountInfo.AccountInvoice.company') : $t('AccountInfo.AccountInvoice.institution')) }}</a-tag>
            <a-tag v-if="item.default"
                   color="#EC9231"
                   class="default-mark">{{ $t('AccountInfo.AccountInvoice.default') }}</a-tag>
          </div>
          <div class="detail">
            <span v-if="item.company_code">{{ $t('AccountInfo.AccountInvoice.creditCode') }}: </span>
            <span v-if="item.company_code">{{ item.company_code }}</span>
          </div>
        </div>
        <div v-if="item.title_type !== 0 && item.invoice_type === 1"
             class="tax-tag">
        </div>
        <div class="operation">
          <div v-if="!item.default"
               class="use"
               @click="userOperate.defaultAddr(item)"><span>{{ $t('AccountInfo.AccountInvoice.use') }}</span></div>
          <div v-else
               class="empty"></div>
          <div class="delete"
               @click="userOperate.userDelete(item.id as number)"><span>{{ $t('AccountInfo.AccountInvoice.delete')
              }}</span></div>
        </div>
      </div>
    </div>
    <div class="footer">
      <a-button type="primary"
                @click="addInvoice">
        <template #icon>
          <plus-square-filled />
        </template>
        {{ $t('AccountInfo.AccountInvoice.addTitle') }}
      </a-button>
    </div>
  </div>
  <component :is="addModel"
             v-if="addVoiceModelState"
             :state="addVoiceModelState"
             @refresh-invoice="initialization"
             @dialog-visible-update="addInvoice" />
</template>

<script setup lang="ts">
import { message } from 'ant-design-vue'
import { onMounted, ref } from 'vue'
import type { InvoiceModel } from '../api/interface/InvoiceInterface'
import { invoiceDeleteInfo, InvoiceGet, invoiceUserDefault } from '../api/Invoice'
import addModel from '../components/InvoiceAdd.vue'
import { useI18n } from 'vue-i18n'

const addVoiceModelState = ref<boolean>(false)
const spinningState = ref<boolean>(false)
const invoiceArray = ref<InvoiceModel[]>([])
const { t } = useI18n()

onMounted(() => {
  initialization()
})

// declared Methods
const initialization = (): void => {
  spinningState.value = !spinningState.value
  InvoiceGet().then(result => {
    const { invoices } = result
    invoiceArray.value = invoices
    spinningState.value = !spinningState.value
  })
}

const addInvoice = (): void => {
  addVoiceModelState.value = !addVoiceModelState.value
}

const userOperate = {
  /** 更换默认地址 */
  defaultAddr: (item: InvoiceModel): void => {
    if (item.default) {
      message.error(t('AccountInfo.AccountInvoice.defaultAddressError'))
    } else {
      spinningState.value = !spinningState.value
      invoiceUserDefault(Object.assign(item, { default: true })).then(() => {
        message.success(t('AccountInfo.AccountInvoice.defaultAddressSuccess'))
        initialization()
      }).catch(() => {
        message.error(t('AccountInfo.AccountInvoice.defaultAddressFail'))
      }).finally(() => {
        spinningState.value = !spinningState.value
      })
    }
  },
  /** 删除地址 */
  userDelete: (id: number): void => {
    spinningState.value = !spinningState.value
    invoiceDeleteInfo(id).then(() => {
      message.success(t('AccountInfo.AccountInvoice.deleteSuccess'))
      initialization()
    }).catch(() => {
      message.error(t('AccountInfo.AccountInvoice.deleteFail'))
    }).finally(() => {
      spinningState.value = !spinningState.value
    })
  }
}

</script>




<style lang="less" scoped>
.containerBox {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;

  .title {
    padding: 20px 0;
    font-size: 16px;
    font-family: 'Microsoft YaHei';
    font-weight: 400;
    color: #111111;
  }

  .list {
    flex: 1;
    min-height: 15vh;
    font-family: 'Microsoft YaHei';
    overflow: scroll;

    .item {
      display: flex;
      width: 100%;
      height: 100px;
      border: 1px solid #F1F1F1;
      align-items: center;

      .icon {
        font-size: 24px;
        margin: 20px;
      }

      .info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        flex: 1;

        .main {
          display: flex;
          align-items: center;

          .name {
            font-size: 18px;
            font-weight: bold;
            margin: 0 10px;
          }
        }

        .detail {
          margin: 5px 10px;
        }
      }


      .tax-tag {
        background: url("./assets/imgs/tax.png") no-repeat bottom;
        width: 110px;
        margin-right: 100px;
        height: 100%;
      }

      .operation {
        display: flex;
        align-content: center;
        justify-content: right;

        .use,
        .delete {
          width: 100px;
          height: 100px;
          font-size: 16px;
          font-family: 'Microsoft YaHei';
          font-weight: 400;
          display: flex;
          align-items: center;
          justify-content: center;

          &:hover {
            background-color: #F1F1F1;
          }
        }

        .use {
          cursor: pointer;
          color: #999999
        }

        .empty {
          width: 100px;
          height: 100px;
        }

        .delete {
          cursor: pointer;
          color: #DE4A09;
        }
      }
    }

    .item:not(:last-child) {
      border-bottom: none;
    }
  }

  .footer {
    display: flex;
    justify-content: center;
    padding-top: 25px;

    button {
      width: 120px;
      height: 40px;
      font-size: 14px;
      font-family: 'Microsoft YaHei';
      font-weight: 400;
    }
  }
}
</style>
